import api from '..'

const getNextLesson = (idLesson: number) => {
  return api.post(`/lessons/${idLesson}/next_lesson`)
}

export default getNextLesson
